import classNames from 'classnames';
import React from 'react';
import './CenterPoint.scss';

interface CenterPointProps {
    lat: number;
    lng: number;
    isUsingCurrentLocation: boolean;
    label: string;
    name: string;
}

export const CenterPoint: React.FunctionComponent<CenterPointProps> = (
    props,
) => {
    const classes = classNames('map-center-point', {
        'map-center-point--user-location': props.isUsingCurrentLocation,
    });

    return (
        <div className={classes}>
            <div className="map-center-point__inner" />
        </div>
    );
};
